import { render, staticRenderFns } from "./NewMol.vue?vue&type=template&id=45d33142&"
import script from "./NewMol.vue?vue&type=script&lang=js&"
export * from "./NewMol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports